import { LoanEditableTable } from './LoanEditableTable';

export default LoanEditableTable;
